import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { getAvailabilityState } from '../redux/reducers';
import { AvailabilityCheck } from '../redux/actions/actions';
import { State as Availability } from '../redux/reducers/reducers-availability';
import { Observable } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';

@Injectable()
export class AvailableGuard implements CanActivate {
  available$: Observable<Availability>;

  constructor(private readonly router: Router, private readonly store: Store<Availability>) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(new AvailabilityCheck());
    this.available$ = this.store.pipe(select(getAvailabilityState));

    return this.available$.pipe(
      skipWhile(a => a.checking),
      map(response => {
        if (!response.availability) {
          return true;
        } else {
          console.warn('[MAINTENANCE GUARD]');
          this.router.navigate(['/']);
          return false;
        }
      })
    );
  }
}
